import { loginOperationByMfaApi } from '@eastcoal/api/auth/operationLogin/loginOperationByMfa'
import { loginOperationByPasswordApi } from '@eastcoal/api/auth/operationLogin/loginOperationByPassword'

import { LoginPassword } from '@eastcoal/auth/components/Login/Password'
import { RouteItem } from '@eastcoal/router/types/route'

export const loginRoute: RouteItem = {
  title: '登录页面',
  path: '/login',
  hideInMenu: true,
  element: (
    <LoginPassword
      mfaApi={loginOperationByMfaApi}
      passwordApi={loginOperationByPasswordApi}
    />
  )
}
